import { render, staticRenderFns } from "./TermsDialog.vue?vue&type=template&id=74d801ed"
import script from "./TermsDialog.vue?vue&type=script&lang=js"
export * from "./TermsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports